// eslint-disable-next-line import/extensions, import/no-relative-packages
import * as ReactDOM from '../../node_modules/react-dom/index.js';

// eslint-disable-next-line import/extensions, import/no-relative-packages
export * from '../../node_modules/react-dom/index.js';

export function findDOMNode() {
  return null;
}

export default {
  ...ReactDOM,
  findDOMNode,
};
